import { ProgramLanguageType } from '@/domain/value_objects/language/programLanguageType'
import { ModelAnswerListViewModel } from '@/presentation/viewmodels/modelAnswer/modelAnswerListViewModel'
import { ModelAnswerPageStateViewModel } from '@/presentation/viewmodels/modelAnswer/modelAnswerPageStateViewModel'
import { ModelAnswerSourceCodeViewModel } from '@/presentation/viewmodels/modelAnswer/modelAnswerSourceCodeViewModel'

export class ModelAnswerPresenter {
  private modelAnswerPageStateViewModel: ModelAnswerPageStateViewModel
  private modelAnswerListViewModel: ModelAnswerListViewModel
  private modelAnswerSourceCodeViewModel: ModelAnswerSourceCodeViewModel

  constructor(
    modelAnswerPageStateViewModel: ModelAnswerPageStateViewModel,
    modelAnswerListViewModel: ModelAnswerListViewModel,
    modelAnswerSourceCodeViewModel: ModelAnswerSourceCodeViewModel
  ) {
    this.modelAnswerPageStateViewModel = modelAnswerPageStateViewModel
    this.modelAnswerListViewModel = modelAnswerListViewModel
    this.modelAnswerSourceCodeViewModel = modelAnswerSourceCodeViewModel
  }

  async initState(problemId: string, programLanguage: ProgramLanguageType): Promise<void> {
    this.modelAnswerListViewModel.setModelAnswerList({})
    this.modelAnswerPageStateViewModel.setModelAnswerExpandedList({})
    this.modelAnswerPageStateViewModel.setModelAnswerLoadingList({})
    this.modelAnswerPageStateViewModel.setModelAnswerIsDiffList({})
    this.modelAnswerPageStateViewModel.setPageIndex(0)
    this.modelAnswerPageStateViewModel.setIsNotMoreModelAnswerList(false)
    this.modelAnswerSourceCodeViewModel.setModelAnswerSourceCodeList({})
    await this.addModelAnswerList(problemId, programLanguage, 0)
  }

  async addModelAnswerList(problemId: string, programLanguage: ProgramLanguageType, pageIndex: number): Promise<void> {
    await this.modelAnswerListViewModel.fetchModelAnswerList(problemId, programLanguage, pageIndex)
    for (const judgeId in this.modelAnswerListViewModel.modelAnswerList.value) {
      this.modelAnswerPageStateViewModel.setModelAnswerExpandedFlag(Number(judgeId), false)
      this.modelAnswerPageStateViewModel.setModelAnswerLoadingFlag(Number(judgeId), false)
      this.modelAnswerPageStateViewModel.setModelAnswerIsDiffFlag(Number(judgeId), false)
    }
  }

  async clickSummary(judgeId: number): Promise<void> {
    if (!this.modelAnswerSourceCodeViewModel.isAlreadySourceCodeRequested(judgeId)) {
      this.modelAnswerPageStateViewModel.setModelAnswerLoadingFlag(judgeId, true)
      await this.modelAnswerSourceCodeViewModel.fetchModelAnswerSourceCodeList(judgeId)
      this.modelAnswerPageStateViewModel.setModelAnswerLoadingFlag(judgeId, false)
    }
    this.reverseModelAnswerExpandedFlag(judgeId)
  }

  private reverseModelAnswerExpandedFlag(judgeId: number): void {
    const currentFlag = this.modelAnswerPageStateViewModel.modelAnswerExpandedList.value[judgeId]
    this.modelAnswerPageStateViewModel.setModelAnswerExpandedFlag(judgeId, !currentFlag)
  }
}
